import { TSSInfo } from '@/generated/proto/bridge/models/epoch'
import { ProtobufAnyMessage } from '@/types'

export type StartEpochFormValues = {
  creator: string
  epochId: string
  tssThreshold: string
  tssInfo: Array<{
    certificate: string
    domain: string
    address: string
    active: boolean
  }>
}

export function buildStartEpochMessage(values: StartEpochFormValues): {
  messages: ProtobufAnyMessage[]
} {
  const tssInfo: TSSInfo[] = values.tssInfo.map(info => ({
    certificate: info.certificate,
    domain: info.domain,
    address: info.address,
    active: info.active,
  }))

  return {
    messages: [
      {
        '@type': '/core.bridge.MsgStartEpoch',
        creator: values.creator,
        epochId: Number(values.epochId),
        info: tssInfo,
        tssThreshold: Number(values.tssThreshold),
      },
    ],
  }
}
